import { render } from "./OrcamentoFinal.vue?vue&type=template&id=62df6982&scoped=true"
import script from "./OrcamentoFinal.vue?vue&type=script&lang=js"
export * from "./OrcamentoFinal.vue?vue&type=script&lang=js"

import "./OrcamentoFinal.vue?vue&type=style&index=0&id=62df6982&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62df6982"]])

export default __exports__